import clock from "./clock";
import display from "./display";
import { Handler } from "./handler";
import scoreboard, { Penalty } from "./scoreboard";
import {
    dotPad,
    startFlashingTimeStar,
    stopFlashingTimeStar,
    upperFirst
} from "./util";

export class PlayerPenalty4k extends Handler {
    private playerNumber = "••";
    private time = "••:••";
    private state: "waitingForEnter" | "waitingForNumber" | "waitingForTime" =
        "waitingForEnter";
    private addPenalty: (penalty: Penalty) => void = (penalty: Penalty) => {};
    private num: number = 0;

    constructor(private side: "home" | "guest") {
        super();
    }

    boot(): void {
        const sideF = upperFirst(this.side) as "Home" | "Guest";
        this.addPenalty = scoreboard[`add${sideF}Penalty`].bind(scoreboard);
        this.num = scoreboard[`${this.side}Penalties`].length + 1;

        startFlashingTimeStar();

        this.update();
    }

    public onPop(): void {
        stopFlashingTimeStar();
    }

    update(): void {
        display.line2(
            `${this.num} PL${dotPad(this.playerNumber)} PN${this.time}`
        );
    }

    onKeypad(num: string): void {
        switch (this.state) {
            case "waitingForEnter":
                break;

            case "waitingForNumber":
                this.playerNumber =
                    this.playerNumber.substring(1) + String(num);
                break;

            case "waitingForTime":
                this.time = `${this.time.charAt(1)}${this.time.charAt(
                    3
                )}:${this.time.charAt(4)}${num}`;
                // Any leadng zero is replaced with a space
                if (this.time.charAt(0) === "0") {
                    this.time = ` ${this.time.substring(1)}`;
                }
                break;
        }

        this.update();
    }

    onEnter(): void {
        switch (this.state) {
            case "waitingForEnter":
                this.state = "waitingForNumber";
                this.update();
                break;

            case "waitingForNumber":
                this.state = "waitingForTime";
                this.time = " 2:00";
                this.update();
                break;

            case "waitingForTime":
                clock.popHandler();
                const playerNumber = this.playerNumber.replaceAll("•", " ");
                const time = this.time.replaceAll("•", "0");
                const seconds =
                    +time.substring(0, 2) * 60 + +time.substring(3, 5);
                this.addPenalty({
                    playerNumber: +playerNumber,
                    time: seconds * 1000,
                });
                break;
        }
    }

    onClear(): void {
        switch (this.state) {
            case "waitingForEnter":
                clock.popHandler();
                break;

            case "waitingForNumber":
                this.state = "waitingForEnter";
                break;

            case "waitingForTime":
                this.time = "••:••";
                this.state = "waitingForNumber";
                break;
        }

        this.update();
    }
}
